import type {
    DraggableAttributes,
    DraggableSyntheticListeners,
} from '@dnd-kit/core';

export type DropIndicator = {
    kind: 'line-before' | 'line-after' | 'outline' | 'group-outline';
    targetId: string;
    /** When set, also highlights this group with the pink outline even if kind
     *  is line-before/line-after (used when positioning inside a group). */
    groupId?: string;
} | null;

export type ActiveDrag = {
    id: string;
    type: 'top-goal' | 'top-group' | 'group-goal' | 'preset';
    height: number;
    width: number;
    /** Set when `type` is `preset` — drives merge vs reorder drop zones. */
    presetRuleCount?: number;
} | null;

export interface DragHandleProps {
    setActivatorNodeRef?: (el: HTMLElement | null) => void;
    listeners?: DraggableSyntheticListeners;
    attributes?: DraggableAttributes;
    iconSize?: number;
}

/**
 * Tracks which goal tile or group header is currently selected in the waterfall,
 * used to show the goal editor panel on the right.
 *
 * - `type: 'goal'`  → a single rule is selected → shows GoalForm (inline)
 * - `type: 'group'` → a group header is selected → shows GoalGroupEditorPanel
 */
export type GoalSelectionState =
    | { type: 'goal'; goalId: string; groupId?: string }
    | { type: 'group'; groupId: string }
    | null;

/** Drop indicators that mean "combine preset into an existing group", not insert. */
export const isPresetMergeDropIndicator = (indicator: DropIndicator): boolean =>
    indicator?.kind === 'group-outline' ||
    (indicator?.groupId != null &&
        (indicator.kind === 'line-before' || indicator.kind === 'line-after'));
